module.exports = __webpack_public_path__ + "media/sin100.8c2e63a3.wav";